import React from 'react'
import { NavLink, Route, Switch, useLocation } from 'react-router-dom'
import { NavTabs } from '@abroad/components'
import { PageHeader } from '../components'
import QuestVideo from '../components/QuestMedia/QuestVideo'
import QuestBlogs from '../components/QuestMedia/QuestBlogs'

const QuestMedia = () => {
  const location = useLocation()
  const pages = [
    {
      path: `/admin/experiences-media/blogs`,
      name: 'Blogs',
      defaultUrl: `/admin/experiences-media`,
    },
    {
      path: `/admin/experiences-media/videos`,
      name: 'Videos',
    },
  ]
  return (
    <>
      <PageHeader
        titleText='Experiences Media'
        colClasses='px-0'
        titleClasses='sentence-case-text'
      />

      <div className='pt-5 custom-offset-lg-1 custom-col-lg-12 px-lg-0'>
        <div className='d-flex justify-content-between mb-3'>
          <NavTabs
            pages={pages}
            NavLink={NavLink}
            pathname={location?.pathname}
            hash={location?.hash}
          />
        </div>
        <Switch location={location}>
          <Route
            exact
            strict
            path={[
              `/admin/experiences-media`,
              `/admin/experiences-media/blogs`,
            ]}>
            <QuestBlogs />
          </Route>
          <Route exact strict path={`/admin/experiences-media/videos`}>
            <QuestVideo />
          </Route>
        </Switch>
      </div>
    </>
  )
}

export default QuestMedia
